import { icons } from '../../lib/helpers/icons';
import { AppIconType } from '../../lib/typegen/app-icon-type';
import style from './style.module.scss';

interface ButtonRoundedProps extends React.HTMLAttributes<HTMLButtonElement> {
	iconType: AppIconType;
	padding?: string;
	fontSize?: string;
	backgroundColor?: 'blue';
	iconColor?: 'white';
}

export default function ButtonRounded({
	iconType,
	padding = '2rem',
	fontSize = '6rem',
	backgroundColor = 'blue',
	iconColor = 'white',
	className,
	...props
}: ButtonRoundedProps) {
	const Icon = icons[iconType];

	return (
		<button {...props} className={`${style.button} ${style[`button--${backgroundColor}`]} ${className}`} style={{ padding }}>
			<Icon className={`${style.button__icon} ${style[`button__icon--${iconColor}`]}`} style={{ fontSize }} />
		</button>
	);
}
